import PropTypes from 'prop-types';
import React from 'react';

export function getCategoryImage(color, category) {
  let imageURL = '';
  let alt = '';

  let basePath = '/images/icons/red';
  if (color === 'white') basePath = '/images/icons/white';
  if (color === 'grey') basePath = '/images/icons/grey';

  switch (category) {
    case 'achtung':
      imageURL = `${basePath}/achtung.png`;
      alt = 'Achtung';
      break;
    case 'angriff':
      imageURL = `${basePath}/bombe.png`;
      alt = 'Angriff';
      break;
    case 'chemie':
      imageURL = `${basePath}/chemie.png`;
      alt = 'Chemie';
      break;
    case 'energieversorgung':
      imageURL = `${basePath}/energieversorgung.png`;
      alt = 'Energieversorgung';
      break;
    case 'erdrutsch':
      imageURL = `${basePath}/lawine.png`;
      alt = 'Erdrutsch';
      break;
    case 'fahndung':
      imageURL = `${basePath}/fahndungsaufruf.png`;
      alt = 'Fahndungsaufruf';
      break;
    case 'feuer':
      imageURL = `${basePath}/feuer.png`;
      alt = 'Feuer';
      break;
    case 'hochwasser':
      imageURL = `${basePath}/hochwasser.png`;
      alt = 'Hochwasser';
      break;
    case 'info':
      imageURL = `${basePath}/info.png`;
      alt = 'Info';
      break;
    case 'polizei':
      imageURL = `${basePath}/polizeireports.png`;
      alt = 'Polizeireport';
      break;
    case 'unwetter':
      imageURL = `${basePath}/unwetter.png`;
      alt = 'Unwetter';
      break;
    case 'verkehrsunfall':
      imageURL = `${basePath}/unfall.png`;
      alt = 'Verkehrsunfall';
      break;
    case 'dwd':
      imageURL = `${basePath}/dwd.png`;
      alt = 'Deutscher Wetterdienst';
      break;
    case 'bbk':
    case 'mowas':
      imageURL = `${basePath}/mowas.png`;
      alt = 'Modulares Warnsystem';
      break;
    default:
      break;
  }
  return {
    url: imageURL,
    alt,
  };
}

function CategoryImage(props) {
  let image = getCategoryImage('red', props.category);
  if (props.catastrophe) image = getCategoryImage('white', props.category);
  if (props.read) image = getCategoryImage('grey', props.category);

  return <img src={image.url} alt={image.alt} />;
}

CategoryImage.propTypes = {
  category: PropTypes.oneOf([
    'achtung',
    'angriff',
    'chemie',
    'energieversorgung',
    'erdrutsch',
    'fahndung',
    'feuer',
    'hochwasser',
    'info',
    'polizei',
    'unwetter',
    'verkehrsunfall',
    'bbk',
    'mowas',
  ]),
  catastrophe: PropTypes.bool,
  read: PropTypes.bool,
};

CategoryImage.defaultProps = {
  category: 'info',
  catastrophe: false,
  read: false,
};

export default CategoryImage;



// WEBPACK FOOTER //
// ./src/js/components/CategoryImage.js